import React from "react";
// import {
//     FaGithub,
//     FaLinkedinIn,
// } from "react-icons/fa";

import Section from "../shared/section";
// import Logo from "../../images/logo2.png";
import SocialIcon from "./social-icon";

import {
    FaGithub,
    FaLinkedin,
    FaEnvelope,
    FaCode,
    FaHackerrank,
    FaMediumM,
} from "react-icons/fa"; // Import icons

import "./style.scss";

const emailAddress = "bhujbalsandesh52@gmail.com";

const Footer = () => {
    return (
        <Section
            background="dark"
            className="footer"
        >
            <div className="footer-content-wrapper">
                {/* <div className="footer-logo">
                    <img
                        src={Logo}
                        alt="JS Dev Hindi"
                    />
                </div> */}
                {/* <ul className="footer-menu-items">
                <li
                        className="footer-menu-item"
                        onClick={() => scrollToSection("about")}
                    >
                        About Me
                    </li>
                    <li
                        className="footer-menu-item"
                        onClick={() => scrollToSection("skills")}
                    >
                        Tech Stack
                    </li>
                    <li
                        className="footer-menu-item"
                        onClick={() => scrollToSection("portfolio")}
                    >
                        Portfolio
                    </li>
                    <li
                        className="footer-menu-item"
                        onClick={() => scrollToSection("blogs")}
                    >
                        Blogs & Articles
                    </li>
                    <li
                        className="footer-menu-item"
                        action={() => {
                            scrollToSection("contact");
                        }}
                    >
                        Contact me
                    </li>
                </ul> */}
               

                <div className="social-icons">
                    <SocialIcon
                        color="#FF0000"
                        icon={<FaEnvelope />}
                        href={`mailto:${emailAddress}`}
                        data-path="Email"
                    />
                    <SocialIcon
                        color="#0D2636"
                        icon={<FaGithub />}
                        href="https://github.com/sandesh300"
                        data-path="GitHub"
                    />
                    <SocialIcon
                        color="#0A66C2"
                        icon={<FaLinkedin />}
                        href="https://www.linkedin.com/in/sandesh-bhujbal-b3a16a222/"
                        data-path="LinkedIn"
                    />
                    <SocialIcon
                        color="grey"
                        icon={<FaMediumM />}
                        href="https://medium.com/@sandesh__30_"
                        data-path="Medium"
                    />
                    <SocialIcon
                        color="#f2740d"
                        icon={<FaCode />}
                        href="https://leetcode.com/sandesh_30/"
                        data-path="LeetCode"
                    />
                    <SocialIcon
                        color="#E84C88"
                        icon={<FaHackerrank />}
                        href="https://www.hackerrank.com/bhujbalsandesh52"
                        data-path="HackerRank"
                    />
                </div>
                {/* <div className="bottom-bar">
                    <div
                        className="url-path-display"
                        id="urlPathDisplay"
                    ></div>
                </div> */}

                <div className="bottom-bar">
                    <div className="copyright-text">
                    Copyright © Sandesh. Portfolio Made By Sandesh Bhujbal
                    </div>
                </div>
            </div>
        </Section>
    );
};

export default Footer;
